export class LanguageMenu {
    constructor(domElm) {
        this.domElm = domElm;
        this.addListener()
    }

    addListener() {
        // Children
        this.domElm.querySelector(":first-child").addEventListener("click", (ev) => {
            ev.preventDefault();
            this.domElm.classList.toggle("open");
        });
    }
}
